import {atom} from 'recoil' ;

export const accorAllClose = atom({
    key : "accorAllClose" ,
    default : false
})

// export const accorClose = atom({ // 자식 컴포넌트 -> 부모 컴포넌트
//     key : "accorClose" ,
//     default : 
// })